module.exports = "/images/Drag and Drop.svg?58e4fa64819c6796cff5eb237d805c5c";